import { Form, Input, Row, Col, Button } from "antd";
import React from "react";
interface POCFormProps {
  onFinish: any;
  onFinishFailed: any;
  validateMessages: any;
  pocName: any;
  pocNumber: any;
  handlePocInputChange: any;
  showSavePoc?: boolean;
  handleSavePoc?: () => void;
  isPocSaved?: boolean;
}
const POCForm: React.FC<POCFormProps> = ({
  onFinish,
  onFinishFailed,
  validateMessages,
  pocName,
  pocNumber,
  handlePocInputChange,
  showSavePoc,
  handleSavePoc,
  isPocSaved,
}) => {

  return (
    <Form
      name="pocForm"
      layout="vertical"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      validateMessages={validateMessages}
    >
      <Row gutter={[16, 8]} style={{ marginTop: "1rem" }}>
        <Col xs={24} sm={10}>
          <Form.Item
            name="fullName"
            label="POC Name"
            rules={[{ required: true }]}
          >
            <Input
              placeholder="POC Name"
              name="fullName"
              value={pocName}
              onChange={handlePocInputChange}
              disabled={isPocSaved}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={10}>
          <Form.Item
            name="mobile"
            label="POC Mobile"
            rules={[
              { required: true },
              {
                pattern: /^[0-9]{10}$/,
                message: "POC Mobile must be a valid 10-digit number",
              },
            ]}
          >
            <Input
              maxLength={10}
              placeholder="POC Mobile"
              name="mobile"
              value={pocNumber}
              type="tel"
              onChange={handlePocInputChange}
              disabled={isPocSaved}
            />
          </Form.Item>
        </Col>
        {showSavePoc && handleSavePoc && (
          <Col xs={24} sm={4} style={{ display: "flex", alignItems: "center", paddingTop: "6px" }}>
            <Button
              onClick={handleSavePoc}
              block
              style={{ backgroundColor: "#00A7B5", color: "#fff", border: "none" }}
            >
              Save Poc
            </Button>
          </Col>
        )}
      </Row>
    </Form>
   
  );
};

export default POCForm;
